import Vue from 'vue'
import VueRouter from 'vue-router'
import BuscaCliente from '@/components/cliente/BuscaCliente.vue'
import LoginPage from '@/components/auth/LoginPage.vue'
import authService from '@/services/authService'
import Estudo from "@/components/cliente/Estudo.vue";
import BibleStudyPage from "@/components/bible/BibleStudyPage.vue";
import {rotasNaRaiz} from "@/components/casamento/rotas";

Vue.use(VueRouter)

const routes = [
    // No dominio brunoelauana.com.br o casamento mora na raiz. Precisa vir antes
    // da rota '/' abaixo, que e a home do app principal. Vazio nos outros dominios.
    ...rotasNaRaiz(),
    {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: {requiresAuth: false}
    },
    {
        path: '/',
        name: 'home',
        component: BuscaCliente,
        meta: {requiresAuth: true}
    },
    {
        path: '/busca-cliente',
        name: 'BuscaCliente',
        component: BuscaCliente,
        meta: {requiresAuth: true}
    },
    {
        path: '/estudar',
        name: 'estudar',
        component: Estudo,
        meta: {requiresAuth: true}
    },
    {
        path: '/estudar/lauschecks',
        name: 'estudar-lauschecks',
        component: Estudo,
        meta: {requiresAuth: true}
    },
    {
        path: '/estudo-biblico',
        name: 'EstudoBiblico',
        component: BibleStudyPage,
        meta: {requiresAuth: true}
    },
    // TODO: Criar componente ResultadoBusca
    // {
    //   path: '/resultado-busca',
    //   name: 'ResultadoBusca',
    //   component: () => import('@/views/ResultadoBusca.vue')
    // },
    {
        path: '/cadastro-cliente',
        name: 'CadastroCliente',
        component: () => import('@/components/cliente/CadastroCliente.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/cliente/:id',
        name: 'VisualizarCliente',
        component: () => import('@/components/cliente/VisualizarCliente.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/pagamentos',
        name: 'ListaPagamentos',
        component: () => import('@/components/lista/pagamento/ListaPagamentos.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/compromissos',
        name: 'ListaCompromissos',
        component: () => import('@/components/lista/compromisso/ListaCompromissos.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/clientes',
        name: 'ListaClientes',
        component: () => import('@/components/lista/clientes/ListaClientes.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/modal-examples',
        name: 'ModalExamples',
        component: () => import('@/components/shared/ModalExamples.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/tabs-example',
        name: 'TabsPageExample',
        component: () => import('@/components/shared/TabsPageExample.vue'),
        meta: {requiresAuth: true}
    },
    // Casamento: depois da festa (out/2026) so o mural segue publico. Confirmacao
    // de presenca, presentes, cha de panela e as paginas de retorno do Mercado
    // Pago sairam do ar; links antigos caem no mural.
    {
        path: '/casamento',
        redirect: '/casamento/mural'
    },
    {
        path: '/cha-de-panela',
        redirect: '/casamento/mural'
    },
    {
        path: '/casamento-admin',
        name: 'GiftsAdmin',
        component: () => import('@/components/casamento/GiftsAdmin.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/casamento-admin/presentes',
        name: 'GiftsAdmin',
        component: () => import('@/components/casamento/GiftsAdmin.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/casamento/mural',
        name: 'Mural',
        component: () => import('@/components/casamento/Mural.vue'),
        meta: {requiresAuth: false}
    },
    {
        path: '/casamento/*',
        redirect: '/casamento/mural'
    },
    {
        path: '/casamento-admin/convidados',
        name: 'GuestsAdmin',
        component: () => import('@/components/casamento/GuestsAdmin.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/casamento-admin/mural',
        name: 'MomentsAdmin',
        component: () => import('@/components/casamento/MomentsAdmin.vue'),
        meta: {requiresAuth: true}
    },

    // Módulo Finanças (controle financeiro do casal) — app independente
    {
        path: '/financas/:aba?',
        name: 'Financas',
        component: () => import('@/components/financas/Financas.vue'),
        meta: {requiresAuth: true}
    },

    // Módulo Casa (controle dos aparelhos via servidor no S21) — app independente
    {
        path: '/casa',
        name: 'Casa',
        component: () => import('@/components/casa/Casa.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/casa/cameras',
        name: 'CasaCameras',
        component: () => import('@/components/casa/CasaCameras.vue'),
        meta: {requiresAuth: true}
    },
    {
        path: '/casa/aparelho/:id',
        name: 'CasaAparelho',
        component: () => import('@/components/casa/CasaAparelho.vue'),
        meta: {requiresAuth: true}
    },

    // Rota para redirecionamento de caminhos não encontrados
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    // Verifica se a rota requer autenticação
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth === true);

    // Se a rota requer autenticação e o usuário não está autenticado
    if (requiresAuth && !authService.isAuthenticated()) {
        // Redireciona para login com parâmetro de redirecionamento
        next({
            path: '/login',
            query: {redirect: to.fullPath}
        });
    } else {
        next();
    }
});

export default router
